import { bl_fi_fixed_asset_register_depreciation_run_hdr_RowClass, bl_fi_fixed_asset_register_depreciation_run_hdr_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterDepreciationRunHdrModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_depreciation_run_hdr: bl_fi_fixed_asset_register_depreciation_run_hdr_RowInterface = new bl_fi_fixed_asset_register_depreciation_run_hdr_RowClass();
}

